import React from "react";
import { Box, Typography, Button, IconButton } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 480);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const TourTooltip = ({
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
  size,
}) => {
  const { title, body } = step.content;
  const isMobile = useIsMobile();
  const isCompact = step.data?.compact;

  return (
    <Box
      {...tooltipProps}
      style={{
        backgroundColor: "#1a1a1a",
        borderRadius: 14,
        padding: isMobile ? "20px 18px" : "28px",
        maxWidth: isCompact ? 280 : isMobile ? "calc(100vw - 32px)" : 420,
        minWidth: isCompact ? 220 : isMobile ? 280 : 320,
        border: "1px solid rgba(255, 198, 41, 0.2)",
        boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
        backdropFilter: "blur(10px)",
        position: "relative",
      }}
    >
      {/* Close button */}
      <IconButton
        {...closeProps}
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "rgba(255,255,255,0.5)",
          padding: 4,
        }}
        size="small"
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      {/* Step counter */}
      <Typography
        style={{
          color: "#FFC629",
          fontFamily: "Poppins, sans-serif",
          fontSize: "0.85rem",
          fontWeight: 600,
          marginBottom: 8,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
        }}
      >
        {index + 1} of {size}
      </Typography>

      {/* Title */}
      <Typography
        style={{
          color: "#ffffff",
          fontFamily: "Raleway, sans-serif",
          fontSize: isMobile ? "1.15rem" : "1.35rem",
          fontWeight: "bold",
          marginBottom: 8,
        }}
      >
        {title}
      </Typography>

      {/* Body */}
      <Typography
        style={{
          color: "rgba(255,255,255,0.8)",
          fontFamily: "Poppins, sans-serif",
          fontSize: isMobile ? "0.95rem" : "1.05rem",
          lineHeight: 1.6,
          marginBottom: 20,
        }}
      >
        {body}
      </Typography>

      {/* Navigation buttons */}
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <Button
          {...skipProps}
          style={{
            color: "rgba(255,255,255,0.5)",
            textTransform: "none",
            fontFamily: "Poppins, sans-serif",
            fontSize: "0.95rem",
            padding: "8px 12px",
            minHeight: 44,
          }}
        >
          Skip Tour
        </Button>

        <Box style={{ display: "flex", gap: 8 }}>
          {index > 0 && (
            <Button
              {...backProps}
              style={{
                color: "#FFC629",
                textTransform: "none",
                fontFamily: "Poppins, sans-serif",
                fontSize: "0.95rem",
                border: "1px solid rgba(255,198,41,0.3)",
                borderRadius: 8,
                padding: "8px 18px",
                minHeight: 44,
              }}
            >
              Back
            </Button>
          )}
          <Button
            {...primaryProps}
            style={{
              backgroundColor: "#FFC629",
              color: "#000",
              textTransform: "none",
              fontFamily: "Raleway, sans-serif",
              fontWeight: "bold",
              fontSize: "1rem",
              borderRadius: 8,
              padding: "8px 22px",
              minHeight: 44,
            }}
          >
            {isLastStep ? "Finish" : "Next"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TourTooltip;
